import { ComponentDataDestService } from '../component-data-dest.service';
import { ComponentDataSourceService } from '../../component-data-source/component-data-source.service';
import { catchError, map } from 'rxjs';
import { Goal } from '../../../models/goal/Goal.model';
import { GoalDTO } from '../../../dto/goal/goal.dto';
import { environment } from '../../../environment/environment';

export function add_goal(componentDataDestService: ComponentDataDestService, componentDataSourceService: ComponentDataSourceService, data: any) {

    // Convert incoming data to model with proper date handling
    const goalModel = new Goal(
        data.name,
        data.descriptions,
        data.version_start_date ? new Date(data.version_start_date) : new Date(),
        data.version_end_date ? new Date(data.version_end_date) : undefined,
        data.visibility,
        data.goal_id ? data.goal_id : undefined,
        data.base_goal_id ? data.base_goal_id : undefined,
        data.subtypes
    );

    // Validate dates
    if (goalModel.version_start_date && isNaN(goalModel.version_start_date.getTime())) {
        throw new Error('Invalid start date format');
    }
    if (goalModel.version_end_date && isNaN(goalModel.version_end_date.getTime())) {
        throw new Error('Invalid end date format');
    }

    // Convert model to DTO
    const goalDTO = Goal.convertToDTO(goalModel);

    // Send DTO to API and update store data
    const request$ = componentDataDestService.http.post(`${environment.apiUrl}/events/goals`, { goal: goalDTO }).pipe(
        catchError(error => {
            console.error("Error in add_goal:", error);
            throw error;
        }),
        map(response => {
            return response;
        })
    );

    // Use the helper function to handle store update
    componentDataSourceService.updateStoreData(request$, 'goals').subscribe({
        error: (error) => console.error('Subscription error:', error)
    });
} 